import Instrument from "shared/games/instruments/Instrument";
import { MixPuzzleInstrumentGrade } from "./grader";
import { State } from "./reducer";

export function getActiveInstrument(state: State) {
  return getInstrument(state, state.instrument);
}

export function getInstrument(state: State, instrument: Instrument) {
  if (state.grade) {
    if (state.playbackState === "mix") {
      return state.grade.mix[instrument];
    } else {
      return state.grade.answer[instrument];
    }
  }

  return state.mix[instrument];
}

function getInstrumentAudioFiles(state: State, instrument: Instrument) {
  return state.mixPuzzle.looop.instruments[instrument].audio_files;
}

export function getInstrumentsAvailable(state: State) {
  return Object.values(state.mixPuzzle.instruments).map(
    ({ instrument }) => instrument
  );
}

export function getInstrumentsBeingHeard(state: State) {
  if (state.grade) {
    if (state.playbackState === "reference") {
      return state.grade.answer;
    }

    return state.grade.mix;
  }

  if (state.playbackState === "reference") {
    return state.mixPuzzle.instruments;
  }

  return state.mix;
}

export function isMuted(state: State, instrument: Instrument) {
  return state.muted.has(instrument);
}

export function isSoloed(state: State, instrument: Instrument) {
  return state.soloed === instrument;
}

export function isReportCardMode(state: State) {
  return typeof state.grade !== "undefined";
}

function getInstrumentIssues(state: State, instrument: Instrument) {
  return state.grade?.issues[instrument];
}

export function isInstrumentTechniqueCorrect(
  state: State,
  instrument: Instrument,
  technique: keyof MixPuzzleInstrumentGrade
) {
  const issue = getInstrumentIssues(state, instrument);

  if (!issue) {
    return true;
  }

  return !!issue[technique];
}

export function isInstrumentCorrect(state: State, instrument: Instrument) {
  return !getInstrumentIssues(state, instrument);
}

export function isReferenceMode(state: State) {
  return state.playbackState === "reference" && !isReportCardMode(state);
}
